export const SET_SUBMISSION_STAGE = 'SET_SUBMISSION_STAGE';

export function setSubmissionStage(submissionStage) {
  return {
    type: SET_SUBMISSION_STAGE,
    submissionStage
  };
}
